// ABOUTME: Production Scheduling's chrome before the spark nav: NDS's ApplicationFrame under the branded
// ABOUTME: nav bar. Goes when the last site has moved and the sparkNav setting goes with it.

import { ApplicationFrame } from "@nulogy/components";
import ConfirmModal from "components/common/ConfirmModal";
import useApplicationContext from "hooks/apollo/applicationContext/useApplicationContext";
import React from "react";
import ApplicationNavBar from "./navbar/ApplicationNavBar";
import { SPARK_ISOLATE_CLASS } from "./spark/sparkIsolate";

export default function LegacyApplicationLayout({ children }) {
  const { trainingMode } = useApplicationContext();

  return (
    <ApplicationFrame
      className={`appContainer ps-app-content ${SPARK_ISOLATE_CLASS}`}
      navBar={<ApplicationNavBar environment={trainingMode && "TRAINING"} />}
    >
      {children}
      <ConfirmModal />
    </ApplicationFrame>
  );
}
